import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Directive()
export class Debounce implements OnInit, OnDestroy {
  @Input() debounceTime = 250;
  @Output() textChanged = new EventEmitter();
  public textChangedSubject = new Subject<any>();
  public subscription: Subscription;

  ngOnInit() {
    this.subscription = this.textChangedSubject
      .pipe(debounceTime(this.debounceTime), distinctUntilChanged())
      .subscribe((e) => this.emitTextChanged(e));
  }

  emitTextChanged(e) {
    this.textChanged.emit(e);
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }
}
